import { Box } from '@mui/material';
import Logo from "../../../images/2.png";
import styles from "./Loader.module.css";

const Loader = () => {
    return (
        <Box className={styles.loaderBox}>
            <img
                src={Logo}
                alt="Loading..."
                className={styles.loader}
            />
            {/* <p className={styles.loaderText}>Dinest</p> */}
        </Box>
    );
};

export default Loader;
